import type { PortalMeDto } from "../model";

let actor: PortalMeDto | null = null;
const listeners = new Set<() => void>();
export const getPortalActor = () => actor;
export function setPortalActor(value: PortalMeDto) {
	actor = value;
	for (const listener of listeners) listener();
}
export function clearPortalActor() {
	actor = null;
	for (const listener of listeners) listener();
}
export function subscribePortalActor(listener: () => void) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}
